export default __webpack_public_path__ + "static/media/guest_04_renata_prestes.f64caace.png";